import React from 'react'
import styles from "../styles/Footer.module.css"
import logo from "../img/footer_logo.svg"
import linkdin from "../img/linkdin.svg"
import mail from "../img/mail.svg"
import call from "../img/call.svg"
import location from "../img/location.svg"


const Footer = () => {
  return (
    <footer className={styles.footer_container}>
        <div>
            <div className={styles.footer_relico}>
                <img src={logo} alt="logo" />
                <p>Premier management consultancy delivering value creation, enhancement, and realization across diverse industries.</p>
                {/* <a href="#"><img src={linkdin} alt="linkedin" /></a> */}
            </div>
            <div className={styles.footer_links}>
                <h3>Quick Link</h3>
                <a href="#about">About</a>
                <a href="#core">Core Values</a>
                <a href="#services">Services</a>
                <a href="#operating">Leadership</a>
            </div>
            <div className={styles.footer_links2}>
                <h3>Contact</h3>
                <a href="mailto:Rajesh.relan@relicoventures.com" target='_blank'><img src={mail} alt="mail" />Rajesh.relan@relicoventures.com</a>
                <a href="#" className={styles.address}><img src={location} alt="location" />421, The Magnolias, DLF Golf Links, DLF-5, Gurgaon - 122002</a>
            </div>
        </div>
        <p>© 2025 Relico Ventures LLP. All rights reserved.</p>
    </footer>
  )
}

export default Footer